var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-content-filters',{staticClass:"filters"},[_c('app-content-filters-search',{model:{value:(_vm.filter.search),callback:function ($$v) {_vm.$set(_vm.filter, "search", $$v)},expression:"filter.search"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }